<template>
    <div class="main-wrapper background--gradient">
      <div class="grid">
        <div class="header">
              <button style="border-radius: 0; border: none; background-color: transparent;" @click="$emit('home')"><img src="/assets/icons/mimi-logo.svg"></button>
          </div>
        <div class="content-wrapper">
          <div class="content">
            <video id="vid" style="width: 800px; margin-bottom: 1rem" controls playsinline>
            </video>
            <button class="btn" @click="$emit('next')">Start Demo</button>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
    name: 'IntroVideo',
    emits: [
        "next"
        ],
    props: [
        "vid_src"
    ],
    mounted() {
        var vid = document.getElementById('vid')
        vid.src = this.vid_src
    }
  }

</script>

<style>

.content-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #000000;
  height: 100%;
}

.content {
  display: grid;
  grid-template-rows: 4;
  justify-items: center;
  font-style: normal;
}

.content button {
    font-size: 1.25rem;
    height: 3rem;
    padding: 0 1.5rem;
    border-radius: 2rem;
    background-color: #FB892F;
    color: #FFF;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    transition: background-color 0.3s;
  font-family: "MontblancType-Regular";
}

.content button:active {
  background-color: #7E47FF;
  transition: background-color 0.3s;
}

</style>